import React from "react";
import useLang from "../../i18n/useLang";

import logoAzae from "../../assets/azae.png";
import logoEurotyre from "../../assets/eurotyre.png";
import logoPatapain from "../../assets/patapain.png";
import logoStGobain from "../../assets/st-gobain.png";
import logoThelem from "../../assets/thelem.png";
import logoVeolia from "../../assets/veolia.png";
import reviewsBadge from "../../assets/reviews.png";

const LOGOS = [
  { src: logoStGobain, alt: "Saint-Gobain" },
  { src: logoVeolia, alt: "Veolia" },
  { src: logoThelem, alt: "Thélem Assurances" },
  { src: logoEurotyre, alt: "Eurotyre" },
  { src: logoPatapain, alt: "Patapain" },
  { src: logoAzae, alt: "Azae" },
];

const CONTENT = {
  fr: {
    label: "Ils optimisent leur visibilité locale avec LocalRanker",
    ratingAlt: "Note 4,7 sur 5 sur Google",
  },
  en: {
    label: "Brands that grow their local visibility with Localranker",
    ratingAlt: "Rated 4.7 out of 5 on Google",
  },
};

const InfoStats = () => {
  const t = CONTENT[useLang()];
  return (
    <div className="trust-section">
      <p className="trust-section__label">
        {t.label}
      </p>
      <div className="trust-section__logos">
        {LOGOS.map((logo) => (
          <div key={logo.alt} className="trust-section__logo">
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </div>

      <div className="trust-section__rating">
        <img src={reviewsBadge} alt={t.ratingAlt} />
      </div>
    </div>
  );
};

export default InfoStats;
